<template>
  <div
    ref="kt_modal_produto_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade"
    tabindex="-1"
    id="kt_modal_produto_editar"
  >
    <div
      class="modal-dialog modal-fullscreen modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/general/gen008.svg"
              class="me-2"
            />Produto
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet
            sapiente aliquid tempora aliquam eius minima sequi sunt, mollitia
            error unde voluptates. Maxime quos, exercitationem repellat
            molestias quia beatae consequuntur ut! Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Laborum aspernatur eos ex iusto
            eveniet minus hic non maxime explicabo. Aliquam necessitatibus iure
            architecto incidunt ad nostrum praesentium cupiditate saepe nihil.
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            obcaecati, dicta exercitationem iure nostrum quae adipisci sit.
            Accusantium recusandae explicabo earum cupiditate quibusdam
            repellat, magni veritatis dolorem rem, adipisci nulla.
            <br />
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet
            sapiente aliquid tempora aliquam eius minima sequi sunt, mollitia
            error unde voluptates. Maxime quos, exercitationem repellat
            molestias quia beatae consequuntur ut! Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Laborum aspernatur eos ex iusto
            eveniet minus hic non maxime explicabo. Aliquam necessitatibus iure
            architecto incidunt ad nostrum praesentium cupiditate saepe nihil.
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            obcaecati, dicta exercitationem iure nostrum quae adipisci sit.
            Accusantium recusandae explicabo earum cupiditate quibusdam
            repellat, magni veritatis dolorem rem, adipisci nulla.
            <br />
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet
            sapiente aliquid tempora aliquam eius minima sequi sunt, mollitia
            error unde voluptates. Maxime quos, exercitationem repellat
            molestias quia beatae consequuntur ut! Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Laborum aspernatur eos ex iusto
            eveniet minus hic non maxime explicabo. Aliquam necessitatibus iure
            architecto incidunt ad nostrum praesentium cupiditate saepe nihil.
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            obcaecati, dicta exercitationem iure nostrum quae adipisci sit.
            Accusantium recusandae explicabo earum cupiditate quibusdam
            repellat, magni veritatis dolorem rem, adipisci nulla.
            <br />
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet
            sapiente aliquid tempora aliquam eius minima sequi sunt, mollitia
            error unde voluptates. Maxime quos, exercitationem repellat
            molestias quia beatae consequuntur ut! Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Laborum aspernatur eos ex iusto
            eveniet minus hic non maxime explicabo. Aliquam necessitatibus iure
            architecto incidunt ad nostrum praesentium cupiditate saepe nihil.
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            obcaecati, dicta exercitationem iure nostrum quae adipisci sit.
            Accusantium recusandae explicabo earum cupiditate quibusdam
            repellat, magni veritatis dolorem rem, adipisci nulla.
            <br />
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet
            sapiente aliquid tempora aliquam eius minima sequi sunt, mollitia
            error unde voluptates. Maxime quos, exercitationem repellat
            molestias quia beatae consequuntur ut! Lorem ipsum, dolor sit amet
            consectetur adipisicing elit. Laborum aspernatur eos ex iusto
            eveniet minus hic non maxime explicabo. Aliquam necessitatibus iure
            architecto incidunt ad nostrum praesentium cupiditate saepe nihil.
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque
            obcaecati, dicta exercitationem iure nostrum quae adipisci sit.
            Accusantium recusandae explicabo earum cupiditate quibusdam
            repellat, magni veritatis dolorem rem, adipisci nulla.
            <br />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["exibirModalProduto"],
  props: {
    show: { type: Boolean, required: true },
  },
  methods: {
    modalConsultaProduto(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalProduto", false);
      }
    },
  },
  watch: {
    show() {
      if (this.show === true) {
        //Carregar Produto
      }
    },
  },
};
</script>

<style></style>
